import { AdviceSortMethod, FilterValue } from "../../../../../custom_api/bookarang/types";

export const sortLabels: { [n in AdviceSortMethod]: string } =
{
  "match": "Beste match",
  "popularity": "Populair",
  "pages": "Dikke boeken",
  "!pages": "Dunne boeken",
  "pubdate": "Nieuwe boeken",
  "!pubdate": "Oudere boeken",
}

export type UpdateFilterValue = (id: number, name: string, value: FilterValue) => void
